module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBold.233d78d0.ttf";